import { GraphicMeta } from './Survey/Survey'

export const defaultViewportDimensions = {
  width: 1200,
  height: 1200,
}

/** Fits `_0201_…MusiqueAPICadre` hole (~198×198 @ 48,24); slight underlap under the frame. */
export const defaultAlbumImageBox: GraphicMeta = {
  xOffset: 41,
  yOffset: 18,
  width: 213,
  height: 212,
  zIndex: 100,
  preserveAspectRatio: 'none',
}

/** Fits `_0208_…APIFilmsCadre` hole (~198×294 @ 426,24); slight underlap under the frame. */
export const defaultMovieImageBox: GraphicMeta = {
  xOffset: 418,
  yOffset: 18,
  width: 214,
  height: 308,
  zIndex: 100,
  preserveAspectRatio: 'none',
}

export const defaultBookImageBox: GraphicMeta = {
  xOffset: 1024,
  yOffset: 311,
  width: 63,
  height: 90,
  zIndex: 200,
}

/**
 * Frame hole under `_0211_…FrameDrapeaux` (trim ≈ 270×186 @ 875,28).
 * Nudge a few px left + down so the flag tucks under the frame edges (frame z > flag z).
 */
export const defaultCountryImageBox: GraphicMeta = {
  xOffset: 869,
  yOffset: 28,
  width: 276,
  height: 190,
  zIndex: 100,
  preserveAspectRatio: 'none',
}
